import EnumValueNotFoundException from '~/errors/EnumValueNotFoundException';

import { type DeliveryNoteListItem } from '~/data/deliveryNote/types';

import { log } from '~/utils/logging';

const i18nMap = {
  arrived: 'Übergabe',
  cancelled: 'Storniert',
  default: 'Nicht gefunden',
  delivered: 'Geliefert',
  imported: 'Importiert',
  inTransport: 'In Transport',
  readyForOutput: 'Ausgabe',
  settled: 'Geliefert', // Deprecated: only used in old dlns
};

export const calculateProcessState = (
  assetMain: Partial<DeliveryNoteListItem> = {},
) => {
  if (!assetMain?.processState) {
    return i18nMap.default;
  }

  const processState = assetMain?.processState;

  if (processState === 'settled') {
    // Move status 'settled' away from process state
    return i18nMap.delivered;
  }

  const status = i18nMap[processState];

  if (!status) {
    log.error({
      message: `Invalid process state: ${processState}`,
      error: new EnumValueNotFoundException(
        `Invalid process state: ${processState}`,
      ),
    });

    return i18nMap.default;
  }

  return status;
};
